import { Component } from 'react';
import FJDropDown from '../../../../common/components/FJDropDown/FJDropDown';
import classNames from 'classnames';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJArrowBottomIcon from '../../../../assets/svg/textToVideo/button-pull-down.svg?react';
import FJVoicePlayIcon from '../../../../assets/svg/textToVideo/voice-play.svg?react';
import FJVoiceStopIcon from '../../../../assets/svg/textToVideo/voice-stop.svg?react';
import FJEvent from '../../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';

import FJTextWithEllipsisChildren from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisChildren';
import styles from './FJVoiceDropList.module.less';
import PropTypes from 'prop-types';

class FJVoiceDropList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            audioUrl: '',
            loading: false,
            isPlaying: false,
            playId: '',
            isShowDropDown: false,
        };
    }

    componentDidMount() {
        this.ubsubscribe = FJEvent.subscribe(FJ_EVENT_TYPE.STOP_AUDIO_IN_TTS, () => {
            this._pause();
        });
        this.ubsubscribePreview = FJEvent.subscribe(FJ_EVENT_TYPE.STOP_PREVIEW_VOICE_IN_TTS, () => {
            this._pause();
        });
    }
    componentWillUnmount() {
        this.ubsubscribe();
        this.ubsubscribePreview();
    }

    _pause = () => {
        this.audioRef && this.audioRef.pause();
        this.setState({
            isPlaying: false,
            loading: false,
            playId: null,
        });
    };
    _play = () => {
        this.audioRef && this.audioRef.play();
        this.setState({
            loading: false,
            isPlaying: true,
        });
    };
    _onIconClick = (e, info) => {
        this.props?.stopPreview();
        e.stopPropagation();
        if (this.state.isPlaying) {
            this.audioRef.pause();
            this.setState({
                audioUrl: info.url,
                loading: true,
                isPlaying: false,
                playId: info.id,
            });
        } else {
            const tempId = this.state.playId;
            if (tempId === info.id) {
                this.audioRef.currentTime = 0;
                this.audioRef.play();
                this.setState({
                    isPlaying: true,
                });
            } else {
                this.setState(
                    {
                        audioUrl: info.url,
                        loading: true,
                        isPlaying: false,
                        playId: info.id,
                    },
                    () => {
                        if (this.audioRef.readyState >= 2) {
                            this._play();
                        }
                    },
                );
            }
        }
    };

    _onLoadedData = () => {
        if (this.state.playId && this.state.isShowDropDown) {
            this._play();
        }
    };

    _onEnded = () => {
        this.setState({
            isPlaying: false,
        });
    };

    _onError = () => {
        this.setState({
            isPlaying: false,
            loading: false,
        });
    };

    /**
     * @description 渲染页面
     * @private
     */
    _getComp = () => {
        const { hasIcon = false } = this.props;
        const { isPlaying, playId, isShowDropDown } = this.state;
        return this.props.list.map(item => {
            return (
                <div
                    key={item.id}
                    className={classNames(styles.item, item.id === this.props.id ? styles.active : '')}
                    onClick={this._onClick.bind(this, item.id)}
                >
                    <FJTextWithEllipsisChildren
                        isRender={isShowDropDown}
                        className={styles.text}
                        title={FJLocalStore._(item.text) + (item.gender ? '(' + item.gender + ')' : '')}
                    >
                        {FJLocalStore._(item.text)}
                        {item.gender ? <span>({item.gender})</span> : null}
                    </FJTextWithEllipsisChildren>
                    {hasIcon && item.url ? (
                        <div
                            className={styles.play_icon}
                            onClick={e => {
                                this._onIconClick(e, item);
                            }}
                        >
                            {isPlaying && playId === item.id ? <FJVoiceStopIcon /> : <FJVoicePlayIcon />}
                        </div>
                    ) : null}
                </div>
            );
        });
    };

    /**
     * @description 选中item
     * @param id
     * @private
     */
    _onClick = id => {
        if (this.props.id !== id) {
            this.props.onClick && this.props.onClick(id);
        }
        this._dropMenu.hide();

        this._pause();
    };

    _onHide = () => {
        this._pause();
        this.setState({
            isShowDropDown: false,
        });
    };

    _onShow = () => {
        this.setState({
            isShowDropDown: true,
        });
    };

    render() {
        let { id, style, className, overlayStyle, disabled = false, isShowGeneral = false, zIndex } = this.props;

        let obj = this.props.list.find(item => {
            return item.id === id;
        });

        const showName = obj ? FJLocalStore._(obj.text) : isShowGeneral ? FJLocalStore._('general') : '';
        const gender = obj ? obj.gender : '';
        let boxListCn = styles.list_box;
        let boxCn = styles.box;
        boxListCn = classNames(boxListCn, className);
        boxCn = classNames(boxCn, className, disabled ? styles.disabled : '');
        return (
            <>
                <FJDropDown
                    overlay={
                        <div className={boxListCn} style={overlayStyle} data-auto-id='APP_Voice_Drop_List'>
                            <FJVerticalScroller style={{ height: '100%' }}>{this._getComp()}</FJVerticalScroller>
                        </div>
                    }
                    hasArrow={false}
                    ref={ele => {
                        this._dropMenu = ele;
                    }}
                    disabled={disabled}
                    triggerDisplay={'flex'}
                    onHide={this._onHide}
                    onShow={this._onShow}
                    zIndex={zIndex}
                >
                    <div className={boxCn} style={style}>
                        <FJTextWithEllipsisChildren
                            className={styles.text}
                            title={showName + (gender ? '(' + gender + ')' : '')}
                        >
                            {showName}
                            {gender ? <span>({gender})</span> : null}
                        </FJTextWithEllipsisChildren>
                        <FJArrowBottomIcon className={styles.icon} />
                    </div>
                </FJDropDown>
                {this.state.isShowDropDown && (
                    <audio
                        src={this.state.audioUrl}
                        className={styles.audio}
                        ref={ele => (this.audioRef = ele)}
                        onLoadedData={this._onLoadedData}
                        onEnded={this._onEnded}
                        onError={this._onError}
                    />
                )}
            </>
        );
    }
}

FJVoiceDropList.propTypes = {
    list: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    stopPreview: PropTypes.func,
    hasIcon: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    overlayStyle: PropTypes.object,
    disabled: PropTypes.bool,
    isShowGeneral: PropTypes.bool,
    zIndex: PropTypes.number,
};

export default FJVoiceDropList;
